'use strict';exports.__esModule = true;var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require('react');var _react2 = _interopRequireDefault(_react);

var _chats = require('../../../../../../static/icons/chats.svg');var _chats2 = _interopRequireDefault(_chats);
var _MessageBlock = require('./MessageBlock.scss');var _MessageBlock2 = _interopRequireDefault(_MessageBlock);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MessageBlock = function MessageBlock(_ref) {var
  children = _ref.children,
  title = _ref.title,
  subtitle = _ref.subtitle;return (

    _react2.default.createElement('div', { className: _MessageBlock2.default.messages },
      _react2.default.createElement('img', { className: _MessageBlock2.default.icon, src: _chats2.default, alt: 'chart icon' }),
      _react2.default.createElement('div', { className: _MessageBlock2.default.content },
        _react2.default.createElement('div', { className: _MessageBlock2.default.text },
          _react2.default.createElement('p', { className: _MessageBlock2.default.title }, title),
          subtitle && _react2.default.createElement('p', { className: _MessageBlock2.default.subtitle }, subtitle)),

        _react2.default.createElement('div', null,
          children))));};exports.default =





MessageBlock;
MessageBlock.propTypes = {
  children: _propTypes2.default.node,
  title: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/components/MessageBlock/MessageBlock.js
// module id = 2770
// module chunks = 0